import axios from "axios";
import { handleLogOut } from "../utils/oathUtils";
import baseUrl from ".";
import { toast } from "react-toastify";
import { triggerToast } from "../widgets/toaster/toastManager";

// Initialize authToken and authUserID
let authToken = "";
let authUserID = "";

// Parse and extract token/userID from localStorage
const storedData = localStorage.getItem("userDetails");

if (storedData) {
  try {
    const storedObject = JSON.parse(storedData);
    if (Array.isArray(storedObject) && storedObject.length > 0) {
      authToken = storedObject[0].x_auth_token;
      authUserID = storedObject[0].x_userid;
    }
  } catch (error) {
    console.error("Failed to parse user details:", error);
  }
}

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: baseUrl,
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (!error.response && error.request) {
      triggerToast("Unable to reach the server. Please check your network connection and try again.", "error");
    }
    else if (
      axios.isAxiosError(error) &&
      (error.response?.status === 408 || error.response?.status === 401)
    ) {
      handleLogOut();
    }
    return Promise.reject(error);
  }
);

export { axiosInstance, authToken, authUserID };
